import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LangChangeEvent } from '@ngx-translate/core';
import { AppPaths } from 'src/app/app-paths.constants';
import { TranslationService } from 'src/metronic/core/_base/layout';
import { LanguageType } from 'src/metronic/core/_config/i18n/language-type.model';

@Component({
  selector: 'rek-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {
  pjaitWebsiteUrl: string;
  pjaitLogoUrl: string;

  readonly currentYear: number = new Date().getUTCFullYear();
  readonly AppPaths: AppPaths = AppPaths;

  constructor(private translate: TranslationService) { }

  ngOnInit() {
    this.initOnLanguageChanges();
  }


  private initOnLanguageChanges(): void {
    this.translate.onLanguageChange()
      .subscribe((lce: LangChangeEvent) => {
        this.initUrls(LanguageType[lce.lang]);
      });
  }

  private initUrls(language: LanguageType): void {
    this.pjaitWebsiteUrl = language === LanguageType.Polish ? 'https://pja.edu.pl/' : 'https://pja.edu.pl/en/';
    this.pjaitLogoUrl = `./assets/media/logos/pjatk-full-${language}__white.png`;
  }
}
